import { Tabs } from 'aui';
import React, { useMemo } from 'react';
import { SupportIconTextReplacer } from '../Icon/parser';
export interface MarkdownTabProp {
  title: string;
  default?: boolean;
}
export function MarkdownTab(props: React.PropsWithChildren<MarkdownTabProp>) {
  const tabNode = useMemo(() => {
    const result = SupportIconTextReplacer(String(props.title), (data) => {
      if (data.type === 'text') return <>{data.value}</>;
      if (data.type === 'mdxJsxFlowElement') {
        return <></>;
      }

      return null;
    });
    return <>{result}</>;
  }, [props.title]);
  return (
    <Tabs.TabPane tab={tabNode}>
      <div className="markdown-child-root">{props.children}</div>
    </Tabs.TabPane>
  );
}

MarkdownTab.attributes = ['title', 'default'] as string[];
MarkdownTab.displayName = 'MarkdownTab';
